
import { defuFn } from '/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/node_modules/.pnpm/defu@6.1.2/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
